import React from "react";
import {IconButton} from "@mui/material";
import {ContentCopyRounded} from "@mui/icons-material";
import {copyToClipboard} from "../../helpers/TextUtils";

const CopyIconButton = ({url, onCopy = copyToClipboard, ariaLabel = "copy", fontSize = 20, sx = {}}) => {
  const buttonStyle = {
    paddingLeft: '0rem',
    ...sx
  };

  return (
    <IconButton
      sx={buttonStyle}
      onClick={() => onCopy(url)}
      aria-label={ariaLabel}
    >
      <ContentCopyRounded sx={{ color: "white", fontSize }} />
    </IconButton>
  );
};

export default CopyIconButton;